import { isValidPhoneNumber } from "react-phone-number-input"

export default class ProfilePage {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.elem.phoneInput = elem.querySelector("#form-mobilenumber")
    self.elem.phoneInputDiv = elem.querySelector("#phoneInputDiv")
    self.elem.phoneSubmit = elem.querySelector("#profileSubmit")
    self.elem.phoneNumberFormError = elem.querySelector("#phoneNumberFormError")
    self.elem.phoneNumberRequired = elem.querySelector("#phoneNumberRequired")
    self.init()
    return self
  }

  init() {
    const self = this
    self.addEventListeners()
  }

  addEventListeners() {
    const self = this
    if (self.elem.phoneInput) {
      self.elem.phoneInput.addEventListener("input", () => this.validatePhoneNumber())
    }
    if (self.elem.phoneSubmit) {
      self.elem.phoneSubmit.addEventListener("click", (e) => this.handleClick(e))
    }
  }

  validatePhoneNumber() {
    const self = this
    if (self.elem.phoneInput && self.elem.phoneInputDiv && self.elem.phoneSubmit && self.elem.phoneNumberFormError && self.elem.phoneNumberRequired) {
      if (self.elem.phoneInput.value) {
        self.elem.phoneNumberRequired.hidden = true
      } else {
        self.elem.phoneNumberRequired.hidden = false
      }
      if (!isValidPhoneNumber(self.elem.phoneInput.value)) {
        self.elem.phoneInputDiv.classList.add("is-invalid")
        self.elem.phoneSubmit.classList.add("is-disabled")
        self.elem.phoneNumberFormError.hidden = false
      } else {
        self.elem.phoneInputDiv.classList.remove("is-invalid")
        self.elem.phoneSubmit.classList.remove("is-disabled")
        self.elem.phoneNumberFormError.hidden = true
      }
    }
  }

  handleClick(e) {
    const self = this
    if (self.elem.phoneInput) {
      if (!self.elem.phoneInput.value) {
        e.preventDefault()
        self.elem.phoneInputDiv.classList.add("is-invalid")
        self.elem.phoneSubmit.classList.add("is-disabled")
        self.elem.phoneNumberRequired.hidden = false
      }
    }
  }
}
